<template>
  <div class="none" style="display: inline-flex">
    <div class="cursors" @click="handleOpen">
      <i class="el-icon-setting"></i>
    </div>
    <el-dialog
      :title="`${$t('common_words.crop_configuration')} ${cropName}`"
      :visible.sync="modals.read"
      :close-on-click-modal="false"
      width="25%"
      @open="getLabelUnit()"
    >
      <div class="row" style="margin: auto">
        <div class="col-12">
          <el-checkbox v-model="model.fahrenheit" @change="getLabelUnit()"
            >{{ $t('climate.degrees_farenheit_questionmark') }}?</el-checkbox
          >
          <hr class="mt-0 mb-4" />
        </div>
        <div class="col-12">
          <fg-input
            min="0"
            type="number"
            :label="`${getMinLabel}: *`"
            v-model="model.minTemperature"
            placeholder="15"
            :name="`${getMinLabel}`"
            v-validate="modelValidations.minTemperature"
            :error="getError(`${getMinLabel}`)"
          />
        </div>
        <div class="col-12">
          <fg-input
            min="1"
            type="number"
            :label="`${getMaxLabel}: *`"
            v-model="model.maxTemperature"
            placeholder="25"
            :name="`${getMaxLabel}`"
            v-validate="modelValidations.maxTemperature"
            :error="getError(`${getMaxLabel}`)"
          />
        </div>
        <div class="text-center col-12 mb-3">
          <hr />
          <l-button wide type="info" class="btn-filter" @click="onSubmit">
            {{ $t('common_words.save') }}
          </l-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import i18n from 'src/i18n';

export default {
  name: 'temp-base-form',
  data() {
    return {
      model: {
        minTemperature: this.minTemperature.value,
        maxTemperature: this.maxTemperature.value,
        fahrenheit: this.isFahrenheit,
      },
      minLabel: this.minTemperature.label,
      maxLabel: this.maxTemperature.label,
      modals: {
        read: false,
      },
    };
  },
  computed: {
    modelValidations() {
      return {
        minTemperature: {
          required: true,
          min_value: 0,
          max_value: Number(this.model.maxTemperature) - 1,
        },
        maxTemperature: {
          required: true,
          min_value: 1,
        },
      };
    },

    getMinLabel() {
      return this.minLabel;
    },

    getMaxLabel() {
      return this.maxLabel;
    },
  },
  props: {
    type: {
      type: Number,
    },
    cropId: {
      type: Number,
    },
    cropName: {
      type: String,
    },
    minTemperature: {
      type: Object,
      default: () => {
        return {
          value: null,
          label: i18n.t('climate.base_temperature'),
        };
      },
    },
    maxTemperature: {
      type: Object,
      default: () => {
        return {
          value: null,
          label: i18n.t('climate.upper_threshold'),
        };
      },
    },
    isFahrenheit: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [MixinForm, MixinMasters],
  methods: {
    getLabelUnit() {
      const minData = { ...this.minTemperature };
      minData.label = minData.label.replace(
        this.model.fahrenheit ? '(°C)' : '(°F)',
        this.model.fahrenheit ? '(°F)' : '(°C)'
      );
      this.minLabel = minData.label;

      const maxData = { ...this.maxTemperature };
      maxData.label = maxData.label.replace(
        this.model.fahrenheit ? '(°C)' : '(°F)',
        this.model.fahrenheit ? '(°F)' : '(°C)'
      );
      this.maxLabel = maxData.label;
    },

    handleOpen() {
      if (this.model.minTemperature === '' && this.model.maxTemperature === '')
        this.$validator.errors.clear();
      this.modals.read = true;
    },

    onSubmit() {
      return this.$validator.validateAll().then((res) => {
        if (res) {
          this.closeModal('read');
          let data = {};

          switch (this.type) {
            case 1:
              data.route = 'crops/points';
              break;
            case 2:
              data.route = 'crops/pointscold';
              break;

            default:
              break;
          }

          data.min_temperature = this.model.minTemperature;
          data.max_temperature = this.model.maxTemperature;
          data.crop = this.cropId;
          data.fahrenheit = this.model.fahrenheit;

          Axios.postMasters(data)
            .then(() => {
              this.$emit('getDataReport', false);
              this.$emit(
                'updateBackground',
                Number(this.model.minTemperature) === 0 ||
                  Number(this.model.maxTemperature) === 0
                  ? false
                  : true
              );

              this.$emit('handleChangeSwitch');
            })
            .catch((error) => {
              console.log(error);
              this.showMessageErrors(error);
            });
        }
      });
    },
  },
};
</script>
